export * from './tick';
export * from './back-arrow';
export * from './invitation';
export * from './man-removed';
export * from './pc';
export * from './book';
export * from './diary';
export * from './apps/notification.icon';
